import * as React from "react";
import { useState } from "react";
import { Button, Text } from "@fluentui/react-components";
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useFilterStyles } from "../styles/filterStyles";
import SpreetailHeader from "../layout/SpreetailHeader";
import DateRangeFilter from "../filters/controls/DateRangeFilter";
import MatchTypeFilter from "../filters/controls/MatchTypeFilter";
import SearchVolumeFilter from "../filters/controls/SearchVolumeFilter";
import ConversionPerformanceFilter from "../filters/controls/ConversionPerformanceFilter";
import CostEfficiencyFilter from "../filters/controls/CostEfficiencyFilter";

const KeywordIntelligenceRoute: React.FC = () => {
  const history = useHistory();
  const filterStyles = useFilterStyles();

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [matchType, setMatchType] = useState("");
  const [searchVolume, setSearchVolume] = useState("");
  const [conversionPerformance, setConversionPerformance] = useState("");
  const [costEfficiency, setCostEfficiency] = useState("");

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setMatchType("");
    setSearchVolume("");
    setConversionPerformance("");
    setCostEfficiency("");
    history.push("/");
  };

  const handleApply = async () => {
    console.log("Apply Keyword Intelligence filters", { startDate, endDate, matchType, searchVolume, conversionPerformance, costEfficiency });
    history.push("/");
  };

  const hasFilters = !!(startDate || endDate || matchType || searchVolume || conversionPerformance || costEfficiency);

  return (
    <div className={filterStyles.filterContainer} style={{ height: "100%", minHeight: 0 }}>
      <SpreetailHeader />
      <div className={filterStyles.filterHeader}>
        <Text size={400} weight="semibold" style={{ color: "#0F172A" }}>
          Keyword Intelligence
        </Text>
        <Text size={200} style={{ color: "#667085", opacity: 0.9, fontSize: "12px" }}>
          Choose some filters to sort through the data!
        </Text>
      </div>

      <div className={filterStyles.filterContent} style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
        <Box className={filterStyles.inputGroup}>
          <label className={filterStyles.labelText}>Date Range</label>
          <DateRangeFilter
            startDate={startDate}
            endDate={endDate}
            onChangeStart={setStartDate}
            onChangeEnd={setEndDate}
          />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <MatchTypeFilter value={matchType} onChange={setMatchType} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <SearchVolumeFilter value={searchVolume} onChange={setSearchVolume} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <ConversionPerformanceFilter value={conversionPerformance} onChange={setConversionPerformance} />
        </Box>

        <Box className={filterStyles.inputGroup}>
          <CostEfficiencyFilter value={costEfficiency} onChange={setCostEfficiency} />
        </Box>

        <div className={filterStyles.actionButtons}>
          <Button 
            appearance="outline" 
            size="medium" 
            onClick={handleCancel} 
            className={`${filterStyles.actionButton} ${filterStyles.cancelButton}`}
            style={{
              border: '1px solid #0461FE',
              color: '#0461FE'
            }}
          >
            Cancel
          </Button>
          <Button 
            appearance="primary" 
            size="medium" 
            onClick={handleApply} 
            disabled={!hasFilters} 
            className={`${filterStyles.actionButton} ${filterStyles.applyButton}`}
          >
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default KeywordIntelligenceRoute;


